@if (isArray()) {
    @let valueArray = viewValueArray();
    <span
        class="se-ui-datagrid-ellipsis_box"
        [matTooltip]="valueArray.join('\n')"
        [matTooltipDisabled]="disabled()"
        matTooltipClass="se-ui-datagrid-tooltip_multi"
    >
        @for (item of valueArray; track $index) {
            <span #cellContent class="se-ui-datagrid-ellipsis_truncate">
                {{ item }}
                <br />
            </span>
        }
    </span>
} @else {
    @let value = viewValue();
    <div
        class="se-ui-datagrid-ellipsis_box se-ui-datagrid-ellipsis_single"
        [matTooltip]="value"
        [matTooltipDisabled]="disabled"
    >
        <span #cellContent class="se-ui-datagrid-ellipsis_truncate">
            {{ value }}
        </span>
    </div>
}
